import { STANDARD_PHYS_DESCR_FIELDS } from './constants';

const UnspecifiedPhysDescriptionFieldConfig = [...STANDARD_PHYS_DESCR_FIELDS];

export default UnspecifiedPhysDescriptionFieldConfig;
